module.exports = __webpack_public_path__ + "img/applepay.161279e5.png";